module.exports = __webpack_public_path__ + "img/Untitled-1-min.10487e0e.jpg";